import { Injectable } from "@angular/core";
import { getEnvironment } from "../config/app.config";
import { of, Observable } from "rxjs";
import { map, catchError, last } from "rxjs/operators";

@Injectable()
export class CowingSdkService {
  static instance: CowingSdkService = new CowingSdkService();
  constructor() {
    return (CowingSdkService.instance = CowingSdkService.instance || this);
  }
}
